var _style, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIceHockey(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Pictogram",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 144 144",
    style: {
      enableBackground: "new 0 0 144 144"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:none;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    cx: 115.7,
    cy: 43.7,
    rx: 9,
    ry: 9
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.5,89.6v28.7c0,2.8,2.3,5.1,5.1,5.1c2.8,0,5.1-2.3,5.1-5.1V87.4c0-1.4-0.6-2.7-1.5-3.6L47.1,47.5 c-2.3,2.3-3.4,5.2-3.4,8.2v26.6H18c-2.8,0-5.1,2.3-5.1,5.1c0,2.8,2.3,5.1,5.1,5.1h30.9c2.8,0,5.1-2.3,5.1-5.1V69L74.5,89.6z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 71.9,
    y: 125.9,
    width: 20.6,
    height: 2.7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 7.6,
    y: 79.7,
    width: 2.7,
    height: 20.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.8,105.1h-17.1l-10.5-10.5c0.4-0.7,0.6-1.6,0.6-2.5V54c0-2.5-1-4.7-2.6-6.4c0,0-23.4-23.4-23.4-23.4c-2-2-5.3-2-7.3,0 L54,45l41.6,43.9v3.3c0,2.8,2.3,5.1,5.1,5.1c1,0,1.8-0.3,2.6-0.7l16.1,16.1c1.2,1.2,2.9,1.9,4.6,1.9h8.9c1.9,0,3.5-1.6,3.5-3.5 v-2.4C136.3,106.7,134.8,105.1,132.8,105.1z M76.2,35.2L86,45H66.3L76.2,35.2z M95.6,85l-22-22h22V85z M133.6,111.1 c0,0.4-0.3,0.8-0.8,0.8H124c-1,0-2-0.4-2.7-1.1l-2.9-2.9h14.4c0.4,0,0.8,0.3,0.8,0.8L133.6,111.1L133.6,111.1z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIceHockey);
export default __webpack_public_path__ + "static/media/iceHockey.6aaca0946f79cb628ed6338bdbdb86ab.svg";
export { ForwardRef as ReactComponent };